import {
  dispatch,
  getWorkspace,
  logOut,
  useAppSelector,
  useLogoutMutation,
  TrackEventType,
  finService,
} from '@zonofi/seller-rtk-store';
import { useNavigate } from 'react-router-dom';
import { SIGNUP_ONBOARDING } from '../navigation';

export const useSignupHomeScreen = () => {
  const navigate = useNavigate();
  const workspace = useAppSelector(getWorkspace);
  const [logoutApi] = useLogoutMutation();

  const logoutUser = () => {
    logoutApi();
    navigate('/login');
    dispatch(logOut());
  };

  const navigateToRetrainScreen = () => {
    navigate(SIGNUP_ONBOARDING.RETRAIN_AGENT.path);
  };

  const navigateToTestScreen = () => {
    finService.trackEvent(TrackEventType.SIGNUP_TEST_STARTED);
    navigate(SIGNUP_ONBOARDING.TEST_AGENT.path);
  };

  return {
    companyName: workspace?.spaceName ?? '',
    logoutUser,
    navigateToRetrainScreen,
    navigateToTestScreen,
  };
};
